var map = {
	"./anm-card.png": 503,
	"./arrow.png": 504,
	"./btn-blue-m-v2.png": 505,
	"./btn-blue-m.png": 506,
	"./btn-white-m-v2.png": 507,
	"./btn-white-m.png": 508,
	"./eeziepay.svg": 509,
	"./fcl.svg": 510,
	"./fpx-logo.svg": 511,
	"./game-blue.png": 512,
	"./game-img.png": 513,
	"./game-white.png": 514,
	"./global-language.svg": 515,
	"./ifm-logo.svg": 516,
	"./logo-anniversary.png": 517,
	"./logo-christmas.png": 518,
	"./logo-cny-dragon.png": 519,
	"./logo-cny.png": 520,
	"./logo-halloween.png": 521,
	"./logo-merdeka.png": 522,
	"./logo-mooncake.png": 523,
	"./logo-raya.png": 524,
	"./logo-uefa.png": 525,
	"./merchant-logo.png": 94,
	"./modal-bg.jpg": 526,
	"./number-bg.png": 527,
	"./pagcor.svg": 528,
	"./pool-bg.png": 529,
	"./side-bar-bg.png": 530,
	"./tether.svg": 531,
	"./x33-logo-wc.png": 532,
	"./x33-logo.png": 533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 613;